// extracted by mini-css-extract-plugin
export var checkboxInputRow = "x_sV";
export var checkboxInputColumn = "x_sW";
export var inputOptionRow = "x_qq";
export var inputOptionColumn = "x_qr";